import { render, staticRenderFns } from "./Prints.vue?vue&type=template&id=2c4e4548&"
import script from "./Prints.vue?vue&type=script&lang=js&"
export * from "./Prints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports